import React, { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    label: string;
    value: string;
  }[];
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  label,
  error,
  options,
  ...props
}, ref) => {
  const isEmptyRequired = !!props.required && (props.value === '' || props.value == null);
  return <div className="w-full" data-id="element-337">
        {label && <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1" data-id="element-338">
            {label}
            {props.required && <span className="text-red-500 dark:text-red-400 ml-1" data-id="element-339">*</span>}
          </label>}
        <select className={cn('flex h-8 w-full rounded-md border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 px-2 py-1 text-sm text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 transition-colors', isEmptyRequired && 'border-red-300 dark:border-red-800 bg-red-50 dark:bg-red-900/20', error && 'border-red-500 dark:border-red-500 focus:ring-red-500', className)} ref={ref} {...props} data-id="element-340">
          <option value="" disabled data-id="element-341">
            Select an option
          </option>
          {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-342">
              {opt.label}
            </option>)}
        </select>
        {error && <p className="mt-1 text-sm text-red-500 dark:text-red-400" data-id="element-343">{error}</p>}
      </div>;
});
Select.displayName = 'Select';